import React from 'react';
//import ReactDOM from 'react-dom';
import  {Redirect, BrowserRouter as Router, Route, Switch}  from 'react-router-dom'
//import  {Redirect}  from 'react-router';
//import Button from '@material-ui/core/Button';
import Navbar from "./components/Navbar/Navbar"
import './App.css';
//2021:import  {MainPage}  from "./components/MainPage";
import  {MainPage}  from "./components/MainPage2024";
import  {CommitteesPage}  from "./components/CommitteesPage";
import  {ProgrammePage}  from "./components/ProgrammePage";
import  {SubmitAbstractPage}  from "./components/SubmitAbstractPage";
import  {PublicationsPage}  from "./components/PublicationsPage";
import ReactGA from 'react-ga';

function App() {
	ReactGA.initialize('G-1X5RZV188S');
	ReactGA.pageview(window.location.pathname + window.location.search);
  return (
    <Router>		
		<div className="App">
		<Navbar />
		<Switch>
			<Route path="/" component={ MainPage } exact />
			<Route path="/index.html" component={ MainPage } exact />
			<Route path="/index.http" component={ MainPage } exact />
			<Route path="/~mariuszz/Bedlewo" component={ MainPage } exact />
			<Route path="/~mariuszz/Bedlewo/" component={ MainPage } exact />
			<Route path="/~mariuszz/Bedlewo/index.html" component={ MainPage } exact />
			<Route path="/~mariuszz/Bedlewo/index.http" component={ MainPage } exact />
			<Route path="/Home" component={ MainPage } exact />
		    <Route path="/Committees" component={ CommitteesPage } exact />			
			<Route path="/Programme" component={ ProgrammePage } exact />
			<Route path="/SubmitAbstract" component={ SubmitAbstractPage } exact />
			<Route path="/Publications" component={ PublicationsPage } exact />
			<Route exact path="/google7c9d306716ea9328.html" render={() => {window.location.href="google7c9d306716ea9328.html"}} />
			<Route exact path="/~mariuszz/Bedlewo/google7c9d306716ea9328.html" render={() => {window.location.href="google7c9d306716ea9328.html"}} />
			<Route component={ MainPage }  />
//			http://fiona.dmcs.p.lodz.pl/~mariuszz/Bedlewo/
//			<Route render={() => <Redirect to={'http://www.hypercomplexseminar.com/'} />} />
		</Switch>			
		</div>
		
	</Router>
  );
}

const ErrorPage = () => (
 <div className="error404">
 <h1>Error404</h1>
 </div>
)

export default App;
